export default class TabNavigationHelper {
    private static _instance: TabNavigationHelper;
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    public setGroupAtt(el: HTMLElement | null): void {
        if (el) {
            if (!el.hasAttribute('group')) {
                el.toggleAttribute('group');
            }
        }
    }
    public setFocusAtt(el: HTMLElement | null): void {
        if (el) {
            if (!el.closest('.fsp-sticky_header_container'))
                el.setAttribute('focusable', '');
        }
    }
    public setModalAtt(el: HTMLElement | null): void {
        if (el) {
            el.setAttribute('group', '');
            el.setAttribute('modal', '');
        }
    }

    public toggleDisabledAtt(root: HTMLElement | null, isDisabled: boolean) {
        if (root) {
            if (isDisabled)
                root.setAttribute('disabled', '');
            else root.removeAttribute('disabled')
        }
    }

    public handleKeyDown(event): void {
        // prevent page jump down on Space btn., click
        if (event.key === ' ') //'Space'
            event.preventDefault();
    }

    public setVariantPanelAttributes(root: HTMLElement | null, isOpen: boolean | undefined) {
        if (root) {
            if (!root.hasAttribute('group'))
                root.setAttribute('group', '');
            if (!root.hasAttribute('modal'))
                root.setAttribute('modal', '');

            if (isOpen) {
                root.removeAttribute('disabled');
            }
            else {
                root.setAttribute('disabled', '');
            }
        }
    }
}
